<template>
  <v-dialog v-model="localDialog" max-width="500px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
        >Add User</v-btn
      >
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localUser.firstName"
                :error-messages="getErrors('firstName')"
                label="First Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localUser.lastName"
                :error-messages="getErrors('lastName')"
                label="Last Name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="localUser.email"
                :error-messages="getErrors('email')"
                rules:
                label="Email Address"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12">
               <v-text-field
                type="number"
                v-model="localUser.weightedProxy"
                label="Weighted Proxy"
              ></v-text-field> 
            </v-col>
            <v-col cols="12">
              
              <Tags v-model="localUser.tags" />
              
            </v-col>
            <v-col cols="5">
              <v-checkbox
                v-model="localUser.scrutineer"
                label="Scrutineer"
              ></v-checkbox>
              
            </v-col>
            <v-col cols="7">
              <v-select
                :items="['guest', 'authenticated', 'staff']"
                v-model="localUser.role"
                label="Role"
              ></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" text @click="close">Cancel</v-btn>
        <v-btn :loading="loading" color="primary darken-1" text @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import api from '@/services/api'
import validator from '@/mixins/validator'
import Tags from '@/components/Admin/Forms/Tags'
import { mapState } from 'vuex';
export default {
  components: {Tags},
  mixins: [validator],
  props: {
    dialog: Boolean,
    user: Object
  },
  data() {
    return {
      loading: false,
    }
  },
  
  computed: {
    ...mapState({
      event: (state) => state.events.event
    }),
    formTitle() {
      return this.user._id === undefined ? 'New User' : 'Edit User'
    },
    localDialog: {
      get: function() {
        return this.dialog
      },
      set: function(val) {
        this.$emit('dialog', val)
        return val
      }
    },
    localUser: {
      get: function() {
        return this.user
      },
      set: function(val) {
        this.$emit('update', val)
      }
    }
  },
  watch: {
    search(val) {
      if (val) {
        this.getUserList(val)
      }
    }
  },
  
  methods: {
    async save() {
      this.loading=true
      try {
        if (!this.user._id) {
          await api.createUser(this.event._id, this.user)
        } else {
          if (typeof this.user.proxy === 'undefined') {
            this.user.proxy = null
          }
          await api.saveUser(this.user._id, this.user)
        }
        this.$emit('update', this.user)
        this.loading=false
        this.close()
        
      } catch (err) {
        this.loading=false
        //console.log(err.response.data)
        this.errors = err.errors
      }
    },
    async close() {
      this.localDialog = false
      this.localUser = {}
      this.errors = []
    }
  }
}
</script>
